import { Button, Col, Layout, Row, Divider } from "antd";
import { useState, useEffect } from "react";
import Sugopic from "./Image";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const App = ({ footerColor = "#C9D7DD", footerData = [] }) => {
  const [kind, setkind] = useState([
    {
      label: "全部",
      key: `/officialweb/frontend`,
    },
  ]);
  const [iconData, setIconData] = useState();
  const [files, setFiles] = useState([]);
  const [footerLogo, setFooterLogo] = useState([]);

  const get_picture = (file_id) => {
    let file = files.find((element) => element.file_id === file_id);
    let file_url = file?.file_url;
    return file_url;
  };
  const getAllpictures = (temp) => {
    temp.forEach((element) => {
      if (element?.file_id) {
        axios
          .get("/component/file", {
            responseType: "blob",
            params: {
              file_id: element?.file_id,
            },
          })
          .then((response) => {
            var blob_ = new Blob([response.data], {
              type: "image/jpg", // this is the only MIME for SVG
            });
            const dataurl = URL.createObjectURL(blob_);
            setFiles((pre) => {
              return [
                ...pre,
                {
                  file_id: element?.file_id,
                  file_url: dataurl,
                },
              ];
            });
          });
      }
    });
  };

  useEffect(() => {
    if (footerData && footerData.length !== 0) {
      footerData?.classify_structure_type_data.forEach(
        (classify_structure_type_data) => {
          if (classify_structure_type_data.title === "頁尾Logo") {
            getAllpictures(
              classify_structure_type_data?.classify_structure_type_file_data ??
                []
            );
            classify_structure_type_data?.classify_structure_type_file_data.forEach(
              (file) => {
                setFooterLogo(file);
              }
            );
          }
        }
      );
      // setFooterInformation(footerData?.classify_structure_type_data)
    }
  }, [footerData]);
  // useEffect(() => {
  //     console.log(footerInformation)
  //     footerInformation?.forEach((footerData) => {
  //         footerData?.classify_structure_type_data.forEach((classify_structure_type_data) => {
  //             if (classify_structure_type_data.title === 'Logo') {
  //                 getAllpictures(classify_structure_type_data?.classify_structure_type_file_data ?? [])
  //             }
  //         })
  //     })
  // }, [footerInformation])
  return (
    <Layout.Footer style={{ backgroundColor: footerColor, height: "auto" }}>
      <Row justify={"space-between"} gutter={[8, 8]}>
        {footerData?.view_count && footerData?.view_count.length !== 0 ? (
          <Col
            span={24}
            style={{
              textAlign: "right",
              paddingTop: "2.5vh",
              fontSize: "2vh",
            }}
          >
            網站瀏覽人次：{footerData?.view_count}
          </Col>
        ) : (
          <></>
        )}
        <Col lg={8} md={24} sm={24} xs={24}>
          <Row justify={"space-between"} gutter={[8, 8]}>
            <Col span={24}>
              <Divider
                orientation="center"
                style={{ fontSize: "3vh", color: "#243b24" }}
              >
                聯絡我們
              </Divider>
            </Col>
            {footerData?.contact_person &&
            footerData?.contact_person.length !== 0 ? (
              <Col span={24} style={{ paddingTop: "2.5vh", fontSize: "2vh" }}>
                聯絡人：{footerData?.contact_person}
              </Col>
            ) : (
              <></>
            )}
            <Col span={24} style={{ paddingTop: "2.5vh", fontSize: "2vh" }}>
              電話：{footerData?.phone}
            </Col>
            <Col span={24} style={{ paddingTop: "2.5vh", fontSize: "2vh" }}>
              信箱：{footerData?.email}
            </Col>
            <Col span={24} style={{ paddingTop: "2.5vh", fontSize: "2vh" }}>
              地址：{footerData?.address}
            </Col>
            {/* <Col span={24} style={{ paddingTop: '2.5vh', fontSize: '2vh' }} >
                                    <span style={{ fontSize: '3vh', color: '#243b24' }}>連絡我們</span>
                                </Col> */}
            <Col span={24} style={{ fontSize: "2vh" }}>
              <Row justify={"start"}>
                {iconData?.map((tmp) => (
                  <>
                    <Col
                      key={tmp.community_connect_id}
                      style={{ padding: "2.5vh 2.5vh 0 0" }}
                    >
                      <Button
                        onClick={() => window.open(tmp.community_link)}
                        style={{
                          height: "48px",
                          width: "48px",
                          border: "white",
                          padding: "0px",
                          borderRadius: "50%",
                          overflow: "hidden",
                        }}
                      >
                        <Sugopic img={tmp.icon} style={{ height: "48px" }} />
                      </Button>
                    </Col>
                  </>
                ))}
                {/* </Row>
                                </Col> */}
              </Row>
            </Col>
          </Row>
        </Col>
        <Col lg={8} md={12} sm={24} xs={24}>
          <div
            style={{ height: "15vw"}}
            dangerouslySetInnerHTML={{
              __html: footerData.google_map_iframe?.replace(
                `width="600" height="450"`,
                `width="100%" height="100%"`
              ),
            }}
          />
        </Col>
        <Col
          lg={8}
          md={12}
          sm={24}
          xs={24}
          style={{
            backgroundImage: footerLogo.file_id
              ? `url(${get_picture(footerLogo.file_id)})`
              : `url(/cram_school/logo.png)`,
            backgroundColor: footerColor,
            backgroundRepeat: "no-repeat",
            height: "15vw",
            // width: '100%',
            backgroundPosition: "center",
            backgroundSize: "contain",
          }}
        ></Col>
        {footerData?.information_community_data &&
        footerData?.information_community_data.length !== 0 ? (
          <Col
            span={24}
            style={{
              textAlign: "right",
              paddingTop: "2.5vh",
              // fontSize: "2vh",
            }}
          >
            <Row justify={"center"} gutter={[8, 8]}>
              {footerData?.information_community_data.map(
                (communityDataItem, communityDataIndex) => {
                  return (
                    <Col>
                      <a href={communityDataItem.link} target="_blank">
                        <img
                          style={{ height: "30px" }}
                          src={communityDataItem.icon}
                        />
                      </a>
                    </Col>
                  );
                }
              )}
            </Row>
          </Col>
        ) : (
          <></>
        )}
      </Row>
    </Layout.Footer>
  );
};

export default App;
